import axios from "axios";
import { gameDetailsURL, gameScreenshotURL } from "../api";

// ? Load games
export const loadDetail = (id) => async (dispatch) => {
  dispatch({
    type: "LOADING_DETAIL",
  });

  // ? Fetch
  const gameDetail = await axios.get(gameDetailsURL(id));
  const gameScreenshots = await axios.get(gameScreenshotURL(id));

  dispatch({
    type: "GET_DETAIL",
    payload: {
      game: gameDetail.data,
      screenshots: gameScreenshots.data,
    },
  });
};
